import {
  getScheduleEndDate,
  parseLocalDate,
  parseClockTime,
} from "@/utils/calendar_utils";

export const getStatus = (duration) => {
  const now = new Date();

  const startDay = parseLocalDate(duration?.startDate);
  let startDate = null;
  if (startDay) {
    const { hours, minutes } = parseClockTime(duration?.startTime, {
      hours: 0,
      minutes: 0,
    });
    startDay.setHours(hours, minutes, 0, 0);
    startDate = startDay;
  }

  const endDate = getScheduleEndDate(duration);

  if (startDate && now < startDate) return "Upcoming";
  if (endDate && now > endDate) return "Expired";
  return "On Going";
};
